import { render, staticRenderFns } from "./consentChecks.vue?vue&type=template&id=1e424616&scoped=true"
import script from "./consentChecks.vue?vue&type=script&lang=js"
export * from "./consentChecks.vue?vue&type=script&lang=js"
import style0 from "./consentChecks.vue?vue&type=style&index=0&id=1e424616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e424616",
  null
  
)

export default component.exports